import { createContext, use } from 'react';

// Bed-configuration text is locale-specific app data, not a react-intl
// message — it doesn't fit react-intl's formatMessage shape and shouldn't
// piggy-back on its `messages` object. Expose it via a dedicated context
// seeded once at the app root.
const BedConfigContext = createContext({});

export const useBedConfig = () => use(BedConfigContext);

export default BedConfigContext;
